module.exports = __webpack_public_path__ + "img/P150T_weapon_156.5aa7ead2.png";